import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContentPage } from 'src/app/enums/content-page.enum';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  contentFooter = ContentPage.esES.footer;
  constructor(
    private router: Router

  ) { }

  ngOnInit() {
    let language = localStorage.getItem('language');
    if (language == 'esEN') {
      this.contentFooter = language == 'esEN' ? ContentPage.esEN.footer : ContentPage.esES.footer;
    }
  }

  goTo(path: string) {
    this.router.navigateByUrl(path);
    setTimeout(() => {
      scrollTo(0, 0);
    });
  }

}
